import { formatDate } from '~/assets/util/helpers'
import { cameraTypesMap } from '~/assets/util/helpers/mappers'
import countries from '~/static/data/countries.json'
import { getKeyByValue } from '~/assets/util/payment'

export const getUserNames = (fullName = '') => {
	const names = fullName.split(' ')

	return {
		firstName: names[0],
		lastName: names[1]
	}
}

export const formatTeam = (team) => {
	return team
		? Object.assign({ id: team.id }, team.attributes, team.attributes.meta, team.attributes.custom)
		: {}
}

export const formatPlan = (plan) => {
	const software = plan.software
	const camera = plan.camera

	const nextInvoice = software.status === 'cancelled'
		? 'cancelled'
		: formatDate(software.endDate)

	const cameraTitle = camera ? cameraTypesMap[camera.type] : ''

	return {
		...plan,
		nextInvoice,
		cameraTitle
	}
}

export const formatWizardPreselection = ({ selection = {}, user = {}, team = {} }) => {
	return {
		...selection,
		signUpData: {
			userData: {
				...user,
				address: user.address || {},
				password: '********',
				confirmPassword: '********'
			},
			teamData: {
				name: team.name,
				sportType: team.sportType,
				role: 'coach',
				hearFrom: 'sawItAtAnEvent'
			}
		}
	}
}

export const formatWizardCameras = (cameras = [], selectedCamera) => {
	const adjustCameraProps = (cam) => {
		if (selectedCamera && selectedCamera.id === cam.id) {
			cam.quantity = selectedCamera.quantity || 1
		} else {
			cam.quantity = 1
		}

		cam.selectedAccessories = []

		return cam
	}

	return {
		primary: cameras
			.filter(camera => camera.price)
			.map(adjustCameraProps)
			.sort((a, b) => a.price - b.price),
		secondary: cameras
			.filter(camera => !camera.price)
			.map(adjustCameraProps)
			.sort((x, y) => {
				const a = x.metadata.cameraType
				const b = y.metadata.cameraType

				return a === b ? 0 : a < b ? 1 : -1
			})
	}
}

export const formatEvent = (event) => {
	const defaultThumbnail = event.attributes.status === 'live' || event.attributes.status === 'upcoming_live' ? '' : '/my/images/events/thumbnail.jpg'
	const defaultStatus = 'vod'

	return {
		id: event.id,
		type: event.type,
		clubId: event.attributes.clubId,
		title: event.attributes.name,
		poster: event.attributes.thumbnails?.hd || defaultThumbnail,
		source: event.attributes.urls,
		gameInfo: event.attributes.gameInfo,
		startDate: formatDate(event.attributes.startDateTime, 'long'),
		endDate: formatDate(event.attributes.endDateTime, 'long'),
		status: event.attributes.status || defaultStatus
	}
}

// TODO: Implement better approach
export const formatFetchParamsFromQuery = (query, excludeParams = []) => {
	const params = {
		...(query.q && { q: query.q }),
		...(query.my && { my: query.my }),
		...(query.limit && { limit: query.limit }),
		...(query.offset && { offset: query.offset }),
		...(query.clubId && { clubId: query.clubId }),
		...(query.startDate && { startDate: query.startDate }),
		...(query.endDate && { endDate: query.endDate }),
		...(query.sort && { sort: query.sort }),
		...(query.sportType && { sportType: query.sportType }),
		...(query.location && { location: query.location })
	}
	const filteredKeys = Object.keys(params).filter(key => !excludeParams.includes(key))

	return filteredKeys.reduce((acc, key) => {
		acc[key] = params[key]

		return acc
	}, {})
}

export const formatTaggedUsers = (taggedUsers, usersData) => {
	if (!usersData || !usersData?.users) {
		return []
	}
	return usersData.users.map((el) => {
		el.isAdmin = usersData.admin.includes(el.id)
		el.enabled = false
		taggedUsers.forEach((item) => {
			if (item.attributes.userId === el.id && item.attributes.status === 'enabled') {
				el.enabled = true
			}
		})
		return el
	}).sort(function (x, y) {
		return Number(y.isAdmin) - Number(x.isAdmin)
	})
}

export const formatTeamPayload = (payload) => {
	if (payload.gender) {
		return payload.gender === 'boys'
			? `${payload.sportType}-men`
			: `${payload.sportType}-women`
	} else if (payload.teamType) {
		return payload.teamType
	} else {
		return payload.sportType
	}
}

export const formatShippingOrderPayload = (payload, type) => {
	const data = {
		line1: payload.address,
		city: payload.city,
		country: getKeyByValue(countries, payload.country),
		state: payload.state
	}

	data[type === 'customer' ? 'postal_code' : 'postalCode'] = payload.postal_code

	return data
}

export const formatCheckoutData = (payload) => {
	return {
		clientSecret: payload.clientSecret || '',
		checkoutMethod: payload.object, // setup_intent || session for klarna
		sessionId: payload.sessionId || '',
		type: payload.type
	}
}

export const formatDateToString = (timestamp, delimitr = '-') => {
	const monthNames = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec']
	const date = new Date(timestamp)

	return `${date.getDate()}${delimitr}${monthNames[+date.getMonth()]} ${date.getFullYear() % 100}`
}
